import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { SET_FEATURES } from './types';
import { fetchFeatures } from '~/services/user';
export default {
  setFeatures: function setFeatures(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, market, locale, sellerContextStoreId, features;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            market = _ref2.market, locale = _ref2.locale, sellerContextStoreId = _ref2.sellerContextStoreId;
            _context.prev = 2;
            _context.next = 5;
            return fetchFeatures({
              market: market,
              locale: locale,
              logger: _this.$logger,
              sellerContextStoreId: sellerContextStoreId
            });
          case 5:
            features = _context.sent;
            commit(SET_FEATURES, features || []);
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            _this.$logger.error('Error fetching features', _context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }))();
  }
};